import { createFileRoute } from '@tanstack/react-router';
import { AiSettingsScreen } from '../features/settings/AiSettings.tsx';

export const Route = createFileRoute('/settings_/ai')({ component: AiSettingsScreen });
